import { App } from 'vue';
import SvgIcon from '@/components/common/SvgIcon.vue';

export const registerSvg = (vue: App<Element>) => {
  vue.component('SvgIcon', SvgIcon);
  const req = require.context('./svg', false, /\.svg$/);
  const requireAll = (requireContext: any) => requireContext.keys().map(requireContext);
  requireAll(req);
};
